import { Button, Card, Container } from 'react-bootstrap'
import { useLocalStorage } from '../contexts/LocalStorageContext'
import { useNavigate } from 'react-router-dom'
import { useSpeech } from '../contexts/SpeechContext'

const History = () => {
  const { config } = useLocalStorage()
  const navigate = useNavigate()
  const { speak } = useSpeech()

  return (
    <>
      <Container>
        <div className="d-flex align-items-center mb-3">
          <Button className="bi bi-home m-3" onClick={() => navigate('/')}>
            <i className="bi bi-house"> </i>
          </Button>
          <h1>Historique</h1>
        </div>

        { config?.history && config.history.map((item) => (
          <Card className="mb-3">
            <Card.Body>
              <h4 className="mb-3 text-center">
                {item.content.summary}
              </h4>
              <div class="d-flex">
                <div class="flex-grow-1 m-3">
                  <Button className="btn-primary w-100" onClick={() => navigate('/ocr-next', { state: { item } })}>
                    <h3><i class="bi bi-box-arrow-up-right"> </i></h3>
                  </Button>
                </div>
                <div class="flex-grow-1 m-3">
                  <Button className="btn-info w-100" onClick={() => speak(item.content.summary)}>
                    <h3><i className="bi bi-volume-up-fill"> </i></h3>
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        ))}
      </Container>
    </>
  )
}

export default History
